import { Link, type LinkProps } from "react-router-dom";
import type { ReactNode } from "react";

/** Card grids: grid-cols-1 keeps the phone column at minmax(0,1fr) so nowrap lines can't widen it (D8). */
export const CARD_GRID_CLS = "grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3";

const cardCls =
  "flex h-full min-w-0 flex-col rounded-2xl border border-line bg-surface p-5 shadow-sm transition [overflow-wrap:anywhere] [&_*]:[overflow-wrap:anywhere] " +
  "hover:border-brand-200 hover:bg-brand-50/40";

export function Card({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={[cardCls, className ?? ""].filter(Boolean).join(" ")}>{children}</div>;
}

export type CardLinkProps = {
  children: ReactNode;
  className?: string;
} & Omit<LinkProps, "className" | "children">;

export function CardLink({ children, className, ...rest }: CardLinkProps) {
  return (
    <Link
      className={[cardCls, "no-underline", className ?? ""].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </Link>
  );
}
